import { useEffect, useRef } from "react";
import { toast } from "sonner";

/**
 * Shows an indefinite toast while `isPending` is true and dismisses it when
 * the work finishes or the caller unmounts. One shared implementation of the
 * ref + effect lifecycle used around long-running mutations.
 */
export const usePendingToast = (isPending: boolean, message: string) => {
  const toastRef = useRef<string | number | null>(null);

  useEffect(() => {
    if (toastRef.current === null && isPending) {
      toastRef.current = toast.message(message, {
        duration: Infinity,
        closeButton: true,
      });
    } else if (toastRef.current !== null && !isPending) {
      toast.dismiss(toastRef.current);
      toastRef.current = null;
    }

    return () => {
      if (toastRef.current !== null) {
        toast.dismiss(toastRef.current);
      }
    };
  }, [isPending, message]);
};
